export const PTO_LEGEND_WEIGHT = {
    DarkerBorder: 0.1,
    Lighter: 0.75
}
